import IconifyIcon from 'components/base/IconifyIcon';

const Rating = {
  defaultProps: {
    emptyIcon: <IconifyIcon icon="material-symbols:star-rounded" color="divider" />,
  },
  styleOverrides: {},
};

export default Rating;
